// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper___2nOgK","content":"styles__content___1N2gD","icon":"styles__icon___23FTi","text":"styles__text___c8TPN"};


//////////////////
// WEBPACK FOOTER
// ./components/qual/Table/LoadingLayer/styles.scss
// module id = m0E5
// module chunks = 0